import script from "./Template-001.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template-001.vue?vue&type=script&lang=ts&setup=true"

import "./Template-001.vue?vue&type=style&index=0&id=31614d03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31614d03"]])

export default __exports__